import { FC } from 'react';
import { SEVERITY, SeverityLevel } from '@silverfort/sf-components';

interface SeverityColumnProps {
    severity: SEVERITY;
}

const SeverityColumn: FC<SeverityColumnProps> = ({ severity }) => {
    return (
        <div className='flex justify-center items-center'>
            <SeverityLevel severity={severity} />
        </div>
    );
};

export default SeverityColumn;
